module.exports = __webpack_public_path__ + "media/assets/images/title_dairyreport_yotei-ba5cdeb3e735ea351c22e29c3c4ed87a.png";